module.exports = __webpack_public_path__ + "static/media/placement-test-h.b46c21df.jpg";